import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Categories() {
  return (
    <section className="bg-background-100 py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">Columns</p>
            <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              四大栏目，看你想看的瓜
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              明星动态、综艺片段、影视花絮、红人视频，全维度覆盖娱乐圈每一处热点。
            </p>
          </div>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/columns/${c.slug}`}
              className="group relative flex h-60 flex-col justify-end overflow-hidden rounded-2xl"
            >
              <img
                src={c.image}
                alt={`${c.name}栏目封面`}
                className="absolute inset-0 h-full w-full object-cover transition duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent"></div>
              <div className="relative p-5">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-background-50/15 text-accent-300 ring-1 ring-inset ring-background-50/30 backdrop-blur">
                  <i className={`${c.icon} text-lg`} />
                </span>
                <h3 className="mt-3 font-heading text-lg font-bold text-background-50">{c.name}</h3>
                <p className="mt-1 text-xs text-background-100/80">{c.desc}</p>
                <p className="mt-3 flex items-center justify-between text-xs text-background-50/90">
                  <span>{c.count.toLocaleString()} 条速递</span>
                  <span className="inline-flex items-center gap-1 text-accent-300 transition group-hover:gap-2">
                    进入栏目 <i className="ri-arrow-right-line" />
                  </span>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}